import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useMediaQuery } from "@mui/material";
import { DatePicker, DatePickerSlotProps } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { merge } from "lodash";
import { FC, useState } from "react";

import CalendarIcon from "web/assets/icons/cafe-calendar.svg";

import getDatepickerSlotProps from "./getDatepickerSlotProps";

interface IDatepickerProps {
  currentValue: Dayjs | null | number | string;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  minDate: Dayjs | number | string | null;
  maxDate?: Dayjs | number | string | null;
  isError?: boolean;
  errorText?: string;
  placeholder: string;
  name?: string;
  dataT1: string;
  id?: string;
  slotProps: DatePickerSlotProps<dayjs.Dayjs, false>;
}

const Datepicker: FC<IDatepickerProps> = ({
  currentValue,
  onChange,
  disabled,
  minDate,
  maxDate,
  isError,
  placeholder,
  name,
  dataT1,
  errorText,
  id,
  slotProps,
}) => {
  const isMobile = useMediaQuery("(max-width: 979px)");
  const [tempValue, setTempValue] = useState<Dayjs | null>(null);

  const minDateFormatted = minDate
    ? dayjs(minDate === "today" ? undefined : minDate)
    : undefined;

  const handleChange = (newValue: Dayjs | null) => {
    if (newValue) {
      const utcMidnightTimestamp = Date.UTC(
        newValue.year(),
        newValue.month(),
        newValue.date()
      );
      onChange(utcMidnightTimestamp);
    } else {
      onChange(null);
    }
  };

  return (
    <DatePicker
      value={currentValue ? dayjs(currentValue) : null}
      views={["year", "month", "day"]}
      openTo="day"
      onAccept={handleChange}
      onChange={(newValue, context) => {
        if (!context.validationError) {
          setTempValue(newValue);
        }
      }}
      disabled={disabled}
      minDate={minDateFormatted}
      maxDate={maxDate ? dayjs(maxDate) : undefined}
      desktopModeMediaQuery="(min-width:980px)"
      format="DD/MM/YYYY"
      slotProps={merge(
        {
          textField: {
            onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Enter") {
                handleChange(tempValue);
              }
            },
          },
        },
        getDatepickerSlotProps({
          id,
          isError,
          errorText,
          placeholder,
          name,
          dataT1,
          disabled,
          isMobile,
        }),
        slotProps
      )}
      slots={{
        openPickerIcon: CalendarIcon,
        switchViewIcon: KeyboardArrowDownIcon,
      }}
    />
  );
};

export default Datepicker;
